import sk from '../../../resources/videovizitky/sk.json';
import cs from '../../../resources/videovizitky/cs.json';

export function getVideovizitkyCopy(locale: string) {
  return locale === 'cs' ? cs : sk;
}
